import React from 'react'
import { useDigitalMarketerShopGate } from '../../hooks/useDigitalMarketerShopGate'
import DigitalMarketerShopModal from '../digitalMarketerShopModal'

interface ShopNowLinkProps
  extends Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> {
  href: string
  /** The plain retailer/product URL to prefill the share-link tool with, if different from `href`. */
  originalUrl?: string
  children: React.ReactNode
}

/**
 * Drop-in replacement for `<a href={trackingLink} target="_blank">` on any single-anchor
 * "shop now" call site. Intercepts the click for Digital Marketers (cashback disabled for
 * that segment) and shows `<DigitalMarketerShopModal>` instead of redirecting to the
 * retailer. Every other user gets the normal click-through, including any `onClick` passed
 * in for analytics/tracking.
 */
const ShopNowLink = React.forwardRef<HTMLAnchorElement, ShopNowLinkProps>(
  (
    { href, originalUrl, onClick, children, target = '_blank', rel, ...rest },
    ref
  ) => {
    const { interceptAnchorClick, modalProps } = useDigitalMarketerShopGate()

    return (
      <>
        <a
          ref={ref}
          href={href}
          target={target}
          rel={rel}
          onClick={interceptAnchorClick(originalUrl || href, onClick)}
          {...rest}
        >
          {children}
        </a>
        <DigitalMarketerShopModal {...modalProps} />
      </>
    )
  }
)

export default ShopNowLink
